import Phaser from 'phaser';

export class Boot extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  create() {
    this.scale.refresh();
    this.scene.start('Preload');
  }
}
